<template>
  <div class="container">
    <div class="main" v-for="(item,index) in summaryCategory" :key="index" style="padding-top: 10px">
      <summary-data :summaryTitle="item.name" :keyCode="item.key"></summary-data>
    </div>
  </div>
</template>

<script>
    import SummaryData from './SummaryData'
    export default {
      name: "Summary",
      components:{
        SummaryData
      },
      // 进入组件更改背景颜色
      beforeCreate() {
        document.querySelector('body').setAttribute('style','background:#F4F5F4')
      },
      // 退出组件还原背景颜色
      beforeDestroy() {
        document.querySelector('body').setAttribute('style','background:#FFFFFF')
      },
      data() {
        return {
          summaryCategory: [],
          summaryTitle: ''
        }
      },
      created() {
        this.getCategory()
      },
      methods: {
        getCategory() {
          this.$axios.get("/api/category/getCategoryList/key?value=moduleUsage").then(res => {
            this.summaryCategory = res.data.data
          })
        }
      },
    }
</script>

<style scoped>
  .container {
    background-color: #F4F5F4;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

  }
  .main {
    width: calc(50% - 5px);
  }
</style
>



// WEBPACK FOOTER //
// src/views/Summary/Summary.vue